import inherited from 'mastodon/locales/bg.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
